import { ddLogger } from './instances/dataDogLogger';
import { serverLogger } from './instances/serverLogger';
const isProduction = process.env.NODE_ENV === 'production';
const isServerSide = typeof window === 'undefined';
export const logger = isServerSide ? serverLogger : isProduction ? ddLogger() : console;

//# sourceMappingURL=index.js.map